/**格式化时间
 * @param {object | string | number} time 时间
 * @param {string} format 格式化形式字符串
 * @return string 格式化时间
*/
export const parseTime = (time, format = 'yyyy-MM-DD HH:mm:ss') => {
  if(!time) return null;
  // 获取日期对象
  let dateObj = typeof time === 'object' ? time : new Date(time);
  // 获取年月日、时分秒
  const formatObj = {
    yyyy: dateObj.getFullYear(),
    yy: dateObj.getFullYear().toString().slice(2),
    MM: dateObj.getMonth() + 1,
    DD: dateObj.getDate(),
    HH: dateObj.getHours(),
    mm: dateObj.getMinutes(),
    ss: dateObj.getSeconds()
  }
  // 使用正则替换format字符串
  const timeStr = format.replace(/(yyyy|yy|MM|DD|HH|mm|ss)/g, (result, key) => {
    const value = formatObj[key];
    return value.toString().padStart(2, '0');//补0
  })
  return timeStr
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}


// WEBPACK FOOTER //
// ./src/util/index.js